<template>
  <div class="deletion-group-modal">
    <!-- CONFIRM EVENT DELETION -->
    <common-modal
      :name="cfmDeletionModalCfg.name"
      :title="cfmDeletionModalCfg.title"
      :primaryAction="cfmDeletionModalCfg.primaryAction"
      :secondaryActions="cfmDeletionModalCfg.secondaryActions"
      height="auto"
    >
      <template #modal-body>
        <div class="md-layout">
          <div class="md-layout-item md-size-100 mt-2">
            <p class="text-gray-600 text-lg">
              Deleted VCR can't be recovered. Are you sure to delete this VCR?
            </p>
          </div>
        </div>
      </template>
    </common-modal>
    <!-- CONFIRM EVENT DELETION -->
  </div>
</template>

<script>
import { getId, Message } from "@/helpers/utils";
import { service_paths } from "@/constants/Services";

export default {
  props: ["selectedEvent"],
  data() {
    return {
      cfmDeletionModalCfg: {
        name: "delete-vcr",
        title: "Deleting VCR confirmation",
        primaryAction: {
          title: this.$t("common.delete"),
          action: this.deleteVCR,
          class: "md-danger"
        },
        secondaryActions: [
          {
            title: this.$t("common.cancel"),
            action: () => {
              this.hide();
            }
          }
        ]
      },
      vcr: ""
    };
  },
  inject: ["refetchEvents"],
  computed: {
    eventId() {
      const eventData = this.selectedEvent?.event;
      return getId(eventData?.extendedProps);
    }
  },
  methods: {
    hide() {
      this.$modal.hide("delete-vcr");
    },
    open(vcr) {
      this.vcr = vcr;
      this.$modal.show("delete-vcr");
    },
    deleteVCR() {
      const payload = {
        vcr: this.vcr
      };
      this.$axios
        .patch(`${service_paths.calendars}/${this.eventId}/delete-vcr`, payload)
        .then(() => {
          this.refetchEvents();
          Message.success("Deleted VCR successfully!");
        });
      this.hide();
    }
  }
};
</script>

<style lang="scss" scoped></style>
